import './App.css';
import { ConfigProvider, theme as antTheme } from 'antd';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './home.tsx';
import { Layout } from './components/Layout';
import { SolutionPage } from './pages/SolutionPage';
import { SoftwarePage } from './pages/SoftwarePage';
import { ContactPage } from './pages/ContactPage';
import { KnowUsPage } from './pages/KnowUsPage';
import { useEffect } from 'react';

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function ThemedApp() {
  return (
    <ConfigProvider
      theme={{
        algorithm: antTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#9e00ff',
          fontFamily: '"Fira Sans", sans-serif',
        },
      }}
    >
      <BrowserRouter>
        <ScrollToTopOnRouteChange />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/know-us" element={<KnowUsPage />} />
          <Route element={<Layout />}>
            <Route path="/solutions/:slug" element={<SolutionPage />} />
            <Route path="/software/:slug" element={<SoftwarePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

function App() {
  return (
    <div className="App">
      <ThemedApp />
    </div>
  );
}

export default App;
